import axios from 'axios'
import i18n from 'i18next'

// creates the autApi call and initializes the route and sets the token in the headers
const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_MIDTIER_URL,
    // baseURL: import.meta.env.VITE_API_MIDTIER_URL + import.meta.env.VITE_API_VERSION
})

const axiosInstanceEntity = axios.create({
    baseURL: import.meta.env.VITE_API_ENTITY_MGMT_URL,
    // baseURL: import.meta.env.VITE_API_ENTITY_MGMT_URL + import.meta.env.VITE_API_VERSION
})

const axiosInstanceEntityGuest = axios.create({
    baseURL: import.meta.env.VITE_API_ENTITY_MGMT_URL,
    // baseURL: import.meta.env.VITE_API_ENTITY_MGMT_URL + import.meta.env.VITE_API_VERSION
})

const addLanguageInterceptor = (instance) => {
    instance.interceptors.request.use((config) => {
        config.headers['Accept-Language'] = i18n.language
        return config
    })
}

;[axiosInstance, axiosInstanceEntity, axiosInstanceEntityGuest].forEach(
    addLanguageInterceptor,
)

export { axiosInstance, axiosInstanceEntity, axiosInstanceEntityGuest }
